export default {
  titles: {
    off50: {
      en: 'Subscribe to Scentbird today: get 50% off first month',
    },
    off25: {
      en: 'Get access to top fragrances & makeup from bestselling brands',
    },
    secondMonthFree: {
      en: 'Subscribe today and get your second month free',
    },
    countdown: {
      en: 'Subscribe now: get 25% off first month',
    },
  },
  subText: {
    en: 'Cancel anytime',
  },
  hint: {
    en: 'Case included in your first order',
  },
  buttonTitle: {
    en: 'Subscribe',
  },
}
